<template>
    <el-dialog
        :title="$t('message.register.agreement')"
        :visible="dialogVisible"
        @close="handleDialog(false)"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        center>
        <div v-html="column_content.content"></div>
    </el-dialog>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
    computed: mapState({
        dialogVisible: state => state.dialogVisible,
        column_content: state => state.other.column_content
    }),
    methods: {
        ...mapMutations([
            "handleDialog",
        ])
    },
}
</script>

<style scoped>

</style>